import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { CourtType } from '../models/court-type.model';

@Injectable()
export class LookupService extends BaseApiService {
    public getLookups = (): Observable<any> => this.get('incident/lookups');

    public getAllIncidentTypes = (): Observable<any> => this.get('incident/lookups/IncidentType');

    public getActiveCourtTypes = (): Observable<{ result: CourtType[] }> => this.get('incident/lookups/CourtTypes');
}
